import jsFetch from 'js-fetch'
const GMAPS_API_KEY = process.env.GMAPS_API_KEY || 'AIzaSyB_RhdBxyiGXe6a0YEsCYBu7mEXu89ACOk'

let $gmap = null

export default function () {
  return new Promise(async (resolve, reject) => {
    if (!$gmap) {
      try {
        $gmap = await jsFetch(`https://maps.googleapis.com/maps/api/js?key=${GMAPS_API_KEY}`, 'google', { async: true }, 5000)

        if (!$gmap) {
          return reject(new Error('Unable to load Google Maps.'))
        }
      } catch (err) {
        return reject(err)
      }
    }

    return resolve($gmap)
  })
}



// WEBPACK FOOTER //
// ./src/library/google-map.js